import React, { Component } from 'react';
import { Card, Col, message, Row } from 'antd';
import { browserHistory } from 'react-router';
import Process from '@comm/workflow/Process';
import ProcessHistory from '@comm/workflow/ProcessHistory';
import Opration from '@comm/workflow/renewal/WorkflowRenewal';
import Comment from '@comm/comment/Index';

import moment from 'moment';
import {
  queryCallbackRenewal,
  queryNextRenewal,
  queryNextRenewalArchive,
  queryNextRenewalScan,
  queryNextRenewalUpload,
  queryReturnRenewal,
} from '@api/administrative/material';
import FormOpen from './FormOpen';
import FormBase from './FormBase';

class Page extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dataInfo: {},
      isLoading: false,
    };
  }

  componentDidMount() {
    const { data } = this.props;
    this.setState({ dataInfo: data });
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      dataInfo: nextProps.data,
    });
  }

  /**
   * 处理流程
   */
  doTask = (pass, refuse, info) => {
    const { dataInfo } = this.state;
    const instance = dataInfo.instance || {};
    const item = {
      instanceUuid: instance.uuid,
    };
    switch (pass) {
      case 'callback':
        this.callbackRenewal(item);
        break;
      case 'next':
        this.nextRenewal(item);
        break;
      case 'nextUpload':
        this.nextRenewalUpload({
          ...item,
          ...info,
        });
        break;
      case 'nextScan':
        this.nextRenewalScan({
          ...item,
          ...info,
        });
        break;
      case 'nextArchive':
        this.nextRenewalArchive({
          ...item,
          ...info,
        });
        break;
      case 'return':
        this.returnRenewal(item, refuse);
        break;
      default:
        break;
    }
  };

  handSubmit = item => {
    const { dataInfo } = this.state;
    this.doTask('nextUpload', item, { ...item, uuid: dataInfo.uuid });
  };

  // 收回
  callbackRenewal = params => {
    queryCallbackRenewal(params).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        browserHistory.go(-1);
      } else {
        message.error(res.message);
      }
    });
  };

  // 通过
  nextRenewal = params => {
    this.setState({ isLoading: true });
    queryNextRenewal(params).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        browserHistory.go(-1);
        this.setState({ isLoading: false });
      } else {
        message.error(res.message);
        this.setState({ isLoading: false });
      }
    });
  };

  // 续证经办人处理
  nextRenewalUpload = params => {
    this.setState({ isLoading: true });
    queryNextRenewalUpload(params).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        browserHistory.go(-1);
        this.setState({ isLoading: false });
      } else {
        message.error(res.message);
        this.setState({ isLoading: false });
      }
    });
  };

  // 扫描件通过
  nextRenewalScan = params => {
    this.setState({ isLoading: true });
    queryNextRenewalScan(params).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        browserHistory.go(-1);
        this.setState({ isLoading: false });
      } else {
        message.error(res.message);
        this.setState({ isLoading: false });
      }
    });
  };

  // 行政归档通过
  nextRenewalArchive = params => {
    this.setState({ isLoading: true });
    queryNextRenewalArchive(params).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        browserHistory.go(-1);
        this.setState({ isLoading: false });
      } else {
        message.error(res.message);
        this.setState({ isLoading: false });
      }
    });
  };

  // 打回
  returnRenewal = (params, refuse) => {
    queryReturnRenewal({
      ...params,
      ...refuse,
    }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        browserHistory.go(-1);
      } else {
        message.error(res.message);
      }
    });
  };

  handleCancel = () => {};

  /**
   * 查看流程
   */
  watchTask = () => {};

  columns = () => [
    {
      title: '日期',
      dataIndex: 'date',
      render: text => (
        <span>{text ? moment.unix(text / 1000).format('YYYY-MM-DD HH:mm') : null}</span>
      ),
    },
    {
      title: '操作内容',
      dataIndex: 'operating',
    },
    {
      title: '处理意见',
      dataIndex: 'refuse',
    },
  ];

  render() {
    const { dataInfo, isLoading } = this.state;
    const instance = dataInfo.instance || {};
    const histories = dataInfo.histories || [];

    const { currentActivity } = instance;
    return (
      <div>
        {currentActivity === undefined || currentActivity.name !== '续证经办人' ? (
          <div>
            <Opration
              op="renewal"
              data={dataInfo}
              doTask={this.doTask}
              watchTask={this.watchTask}
              isLoading={isLoading}
            />
            <FormOpen
              data={dataInfo}
              doTask={this.doTask}
              watchTask={this.watchTask}
              {...this.props}
            />
          </div>
        ) : (
          <FormBase data={dataInfo} handSubmit={this.handSubmit} {...this.props} />
        )}
        <Card title="流程跟踪">
          <Row justify="center">
            <Col span={24} style={{ marginBottom: '16px', fontSize: '14px' }}>
              <div style={{ marginBottom: '16px', fontSize: '14px' }}>流程路径：</div>
              <Process instance={instance} />
            </Col>
            <Col span={24}>
              <ProcessHistory dataSource={histories} />
            </Col>
          </Row>
        </Card>
        <Comment target={{ type: 'renewal', uuid: dataInfo.uuid }} />
      </div>
    );
  }
}

export default Page;



// WEBPACK FOOTER //
// ./src/components/administrative/material/renewal/PageOpen.js